import React from 'react';
import '../styles/App.css';
import '../styles/Plans.css';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';

function PlansPage() {
  const [t] = useTranslation();

  const planOrder = ['payg', 'starter', 'active', 'elite'];
  const metricOrder = [
    'upfront_cost',
    'credits_issued',
    'effective_cost',
    'face_value',
  ];

  return (
    <>
      <NavBar />
      <div className="plans-page">
        <div className="plans-container container">
        <div className="plans-header">
          <h1 className="plans-title">{t('plans.title')}</h1>
          <p className="plans-subtitle">{t('plans.subtitle')}</p>
        </div>

        <section className="plans-grid">
          {planOrder.map((planKey) => (
            <article className="plan-card" key={planKey}>
              <div className="plan-top-row">
                <p className="plan-tier-number">{t(`plans.${planKey}.tier`)}</p>
                <span className="plan-badge">{t(`plans.${planKey}.badge`)}</span>
              </div>
              <h3 className="plan-name">{t(`plans.${planKey}.name`)}</h3>
              <p className="plan-fit">{t(`plans.${planKey}.fit`)}</p>

              <div className="plan-highlights">
                <div className="plan-highlight-pill plan-highlight-pill-discount">
                  <span>{t('plans.labels.discount')}</span>
                  <strong>{t(`plans.${planKey}.discount`)}</strong>
                </div>
                <div className="plan-highlight-pill plan-highlight-pill-capacity">
                  <span>{t('plans.labels.est_classes_short')}</span>
                  <strong>{t(`plans.${planKey}.est_classes`)}</strong>
                </div>
              </div>

              <div className="plan-metrics">
                {metricOrder.map((key) => (
                  <div className="plan-metric-row" key={key}>
                    <span>{t(`plans.labels.${key}`)}</span>
                    <strong>{t(`plans.${planKey}.${key}`)}</strong>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </section>

        <section className="plans-summary">
          <h2 className="plans-summary-title">{t('plans.summary_title')}</h2>
          <ul className="plans-summary-list">
            <li>{t('plans.summary_1')}</li>
            <li>{t('plans.summary_2')}</li>
            <li>{t('plans.summary_3')}</li>
          </ul>
        </section>
        <p className="plans-footnote">{t('plans.credit_note')}</p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PlansPage;
